import { ConnectionType } from 'modules/core/supabase/tables/match-chronology';
import supabase from 'modules/core/supabase/supabase';
import { REMOTE_CONNECTION_TIMEOUT_MS } from 'modules/overlay-v2/domain/constants/readiness';
import { RemoteConnectionState } from 'modules/overlay-v2/domain/interfaces/readiness';
import { useEffect, useState } from 'react';

/**
 * Связь с пультом — единственный пункт чеклиста, который не держит показ табло.
 *
 * Канал к журналу матча может так и не подняться (жёсткий NAT, корпоративный Wi-Fi),
 * а оверлей это переживает: без канала он сам опрашивает журнал раз в 3 секунды
 * (см. `joystick.tsx`). Поэтому ждём отклик отведённое время и идём дальше
 * с предупреждением, а не зависаем на экране подготовки.
 *
 * @param isEnabled ждать ли связь — включается, когда на устройстве появился матч.
 */
function useRemoteConnectionStep(isEnabled: boolean): RemoteConnectionState {
  const [status, setStatus] = useState<ConnectionType>(supabase.matchChronology.connectionStatus.value);
  const [isTimedOut, setIsTimedOut] = useState(false);

  useEffect(() => {
    const callback = (next: ConnectionType) => setStatus(next);
    supabase.matchChronology.connectionStatus.subscribe(callback);

    return () => supabase.matchChronology.connectionStatus.unsubscribe(callback);
  }, []);

  useEffect(() => {
    if (!isEnabled) {
      setIsTimedOut(false);
      return;
    }

    const timer = setTimeout(() => setIsTimedOut(true), REMOTE_CONNECTION_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [isEnabled]);

  if (status === 'SUBSCRIBED') return 'connected';
  return isTimedOut ? 'timedOut' : 'waiting';
}

export default useRemoteConnectionStep;
